import React from 'react';
import { BsChevronRight } from "react-icons/bs";

const Breadcrumbs = ({ paths }) => {
  return (
    <nav aria-label="breadcrumb">
      <ol className="breadcrumb">
        {paths?.map((path, index) => (
          <React.Fragment key={index}>
            <li
              className={`breadcrumb-item ${index === paths?.length - 1 ? 'breadcrumb-item-active' : ''}`}
              aria-current={index === paths?.length - 1 ? 'page' : undefined}
            >
              {path}
            </li>
            {/* Add the '>' separator between items, except for the last one */}
            {index < paths?.length - 1 && <span> <BsChevronRight /> </span>}
          </React.Fragment>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
